import clsx from 'clsx';
import React from 'react';

export type CardBadgeProps = {
  good: boolean;
  children: React.ReactNode;
};

export const CardBadge: React.FC<CardBadgeProps> = ({ good, children }) => (
  <small
    className={clsx(
      'flex flex-shrink-0 self-center px-4 py-1 rounded-full',
      good ? 'bg-green' : 'bg-red text-white'
    )}
  >
    {children}
  </small>
);
